import { useQueries } from "@tanstack/react-query";
import { showNotification } from "../../b2b-common/Notification";
import { useLoginContext } from "../../../App";
import { useContentContext } from "../../layout/Layout";
import useB2BTranslation from "../../b2b-common/hooks/useB2BTranslation";
import { getNonStandardLevelNs } from "../../../services/b2b-frameworks-apiService";

const useNonStandardLevelNs = (frameworkSuite, frameworkIds = []) => {
    const { loginData } = useLoginContext();
    const { setNotification } = useContentContext();
    const { t } = useB2BTranslation('b2b-frameworks');
    
    const fetchNonStandardLevelNs = async (frameworkId) => {
        const { accessToken } = loginData;
        try {
            const nonStdLevelNs = await getNonStandardLevelNs(frameworkSuite, frameworkId, accessToken);
            return nonStdLevelNs;
        } catch (error) {
            console.error('Error fetching non-standard levelNs:', error);
            showNotification(setNotification, t('Error fetching non-standard levelNs: ') + error.message, 'error', 5000);
            throw error;
        }
    };

    const queries = (frameworkIds || []).map(frameworkId => ({
        queryKey: ['nonStandardLevelNs', frameworkSuite, frameworkId],
        queryFn: () => fetchNonStandardLevelNs(frameworkId),
        enabled: !!frameworkId,
        retry: false,
    }));

    const results = useQueries({ queries });

    const frameworkIdToIndexMap = frameworkIds.reduce((acc, frameworkId, index) => {
        acc[index] = frameworkId;
        return acc;
    }, {});

    let nonStandardLevelNs = results.map((result, index) => {
        return {
            frameworkId: frameworkIdToIndexMap[index] || null,
            nonStandardLevelNs: result.data || []
        }
    });

    return nonStandardLevelNs;

}

export default useNonStandardLevelNs;